// import Image from "next/image";
import { Button, Form, Input, Select, Image, message } from "antd";
import { useEffect, useState } from 'react';
import gaTracker from "@/ga";
import { Icon } from "@iconify/react";
import Modal from '@/components-mobile/Modal';
import { countryPhoneCodes } from '@/constants/Phone';
import {
  AllFlowImg, FlowImg1, FlowImg2, FlowImg3, FlowImg4, FlowImg5, FlowImg6,
  AllFlowImgFr, FlowImg1Fr, FlowImg2Fr, FlowImg3Fr, FlowImg4Fr, FlowImg5Fr, FlowImg6Fr
} from '@/config/config';
import EligibleModal from "@/components/EligibleModal";
import { APIRequestSampleCreate, APIRefreshCapStatus } from '@/api';
import styles from './index.module.scss';
import useLanguage from "@/hooks/useLanguage";


const FreeSamplePopup = ({ isVisible, title, sourceData, obtainRef, getCapInvite, reEligible, closePopup, addChange }) => {
  const { t, currentLang } = useLanguage();
  const [form] = Form.useForm();
  const [steps, setSteps] = useState(1);  // 0 tap   1  进来就看到    2  信息填写    3  申样后提示
  useEffect(() => {
    if (isVisible) {
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
      setSteps(1);
    } else {
      // 恢复页面滚动
      document.body.style.overflow = '';
    }
    // 在组件卸载时恢复页面滚动
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  const getSample = () => {
    // setPersonInfo(true);
    APIRefreshCapStatus();
    setSteps(obtainRef ? 2 : 0);
  };
  const clearInfo = () => {
    form.resetFields();
  };
  const handleSubmit = async () => {
    const values = await form.validateFields(); // 触发校验
    let submitValues = {
      ...values,
      productId: sourceData?.productId,
      phoneNum: `+${values.prefix}${' '}${values.phone}`
    };
    delete submitValues.prefix;
    delete submitValues.phone;
    gaTracker.trackEvent("offline_sam_submit_h5");
    console.log('~222', submitValues, values);
    APIRequestSampleCreate(JSON.stringify(submitValues)).then((resp) => {
      console.log("~resp", resp);
      if (resp.data.result) {
        setSteps(3);
        form.resetFields();
      } else {
        message.info(t('free_sample_popup.submit_failed'));
      }
      // closePopup();
    }).catch((error) => {
      closePopup();
      form.resetFields();
      console.log(error, "errorH5");
      message.info(t('free_sample_popup.apply_failed'));
    });

  };

  const prefixSelector = (
    <Form.Item name={"prefix"} noStyle>
      <Select
        style={{
          width: 70,
        }}
        // defaultValue={"86"}
        getPopupContainer={(triggerNode) => triggerNode.parentNode} // 解决被遮挡问题
      >
        {countryPhoneCodes.map((item, index) => (
          <Select.Option key={index} value={item.value}>
            +{item.value}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );

  return (
    isVisible && <div className={styles.overlay}
      onClick={(e) => {
        e.preventDefault();
        setSteps(1);
        closePopup();
      }}
      onTouchMove={(e) => {
        e.preventDefault(); // 阻止默认的触摸移动行为，防止页面滚动
      }}>
      <div className={`${styles.popup} ${isVisible ? styles['popup-enter'] : styles['popup-exit']
        }`} onClick={(e) => e.stopPropagation()} // 阻止事件冒泡，避免点击内容关闭 Popup
      >
        <div className={styles.header}>
          <div className={styles.headerLeft}>{steps !== 3 ? title : ''}</div>
          <div className={styles.headerRight} onClick={() => { setSteps(1); closePopup(); }}>
            <Icon icon='line-md:close' className={styles.headerRightIcon} />
          </div>
        </div>
        {steps !== 3 && <div className={styles.content} onTouchMove={(e) => {
          e.preventDefault(); // 阻止默认的触摸移动行为，防止页面滚动
        }}>
          <div className={styles.productBox}>
            <div className={`${styles.imageBox}`}>
              <img className={`${styles.image} `} src={sourceData?.alyImage} />
            </div>
            <div className={styles.title}>{sourceData?.title}</div>
          </div>
          <div className={styles.info}>
            {steps === 2 ?
              <div>
                <div className={styles.infoSampleTip}>{t('free_sample_popup.note')}</div>
                <div className={styles.infoTitle}>
                  {t('free_sample_popup.fill_info')}
                </div>
              </div>
              : <div className={styles.infoTitle}>
                {t('free_sample_popup.join_program')}
              </div>}

            {steps === 0 ? <div>
              <ol>
                <li className={styles.infoText} style={{ marginTop: '17px', marginLeft: '15px' }}>{t('free_sample_popup.ready_to_join')}
                  <ul>
                    <li className={styles.infoText}>{t('free_sample_popup.highest_commissions', {
                      span: <span className={styles.infoTextDiff}>{t('free_sample_popup.highest_commissions_text')}</span>
                    })}</li>
                    <li><span className={styles.infoTextDiff}>{t('free_sample_popup.offline_samples')}</span></li>
                    <li><span className={styles.infoTextDiff}>{t('free_sample_popup.exclusive_boost')}</span></li>
                    <li className={styles.infoText}>{t('free_sample_popup.personalized_support', {
                      span: <span className={styles.infoTextDiff}>{t('free_sample_popup.one_on_one')}</span>
                    })}</li>
                    <li className={styles.infoText}>{t('free_sample_popup.tiktok_flash_sales')}</li>
                  </ul>
                </li>
                <li className={styles.infoText} style={{ marginTop: '10px', marginLeft: '15px' }}>
                  {t('free_sample_popup.click_button', {
                    obtain: <span className={styles.infoTextDiff}>{t('free_sample_popup.obtain_eligibility')}</span>,
                    partner: <span className={styles.infoTextDiff}>{t('free_sample_popup.partner_link')}</span>,
                    uango: <span className={styles.infoTextDiff}>Uango</span>,
                    accept: <span className={styles.infoTextDiff}>{t('free_sample_popup.accept_request')}</span>
                  })}
                </li>
              </ol>
            </div> : (
              steps === 2 ?
                <Form
                  form={form}
                  autoComplete={"off"}
                  layout={"vertical"}
                  initialValues={{ prefix: '86' }}
                  style={{ marginTop: '12px', marginBottom: '42px' }}
                >
                  <Form.Item
                    label={t('free_sample_popup.address')}
                    name={"address"}
                    rules={[
                      {
                        required: true,
                        message: t('free_sample_popup.address_required'),
                      },
                    ]}
                  >
                    <Input maxLength={500} placeholder={t('free_sample_popup.address_placeholder')} />
                  </Form.Item>
                  <Form.Item
                    label={t('free_sample_popup.zip_code')}
                    name={"zipCode"}
                    rules={[
                      {
                        required: true,
                        message: t('free_sample_popup.zip_code_required'),
                      },
                    ]}
                  >
                    <Input maxLength={20} placeholder={t('free_sample_popup.zip_code_placeholder')} />
                  </Form.Item>
                  <Form.Item
                    label={t('free_sample_popup.email')}
                    name={"email"}
                    rules={[
                      {
                        required: true,
                        message: t('free_sample_popup.email_required'),
                      },
                      { pattern: /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/, message: t('free_sample_popup.email_format_error') }
                    ]}
                  >
                    <Input maxLength={300} placeholder={t('free_sample_popup.email_placeholder')} />
                  </Form.Item>
                  <Form.Item
                    label={t('free_sample_popup.name')}
                    name={"name"}
                    rules={[
                      {
                        required: true,
                        message: t('free_sample_popup.name_required'),
                      },
                    ]}
                  >
                    <Input maxLength={50} placeholder={t('free_sample_popup.name_placeholder')} />
                  </Form.Item>
                  <Form.Item
                    label={t('free_sample_popup.phone')}
                    name={"phone"}
                    rules={[
                      {
                        required: true,
                        message: t('free_sample_popup.phone_required'),
                      },
                      { pattern: /^(\+\d{1,3}( )?)?((\$\d{1,4}\$)|\d{1,4})[- .]?\d{1,4}[- .]?\d{1,9}$/, message: t('free_sample_popup.phone_format_error') }
                    ]}
                  >
                    <Input
                      maxLength={20}
                      addonBefore={prefixSelector}
                      placeholder={t('free_sample_popup.phone_placeholder')} />
                  </Form.Item>
                  <Form.Item
                    label={t('free_sample_popup.product_note')}
                    name={"productNote"}
                  >
                    <Input.TextArea count={{
                      show: true,
                      max: 500,
                    }}
                      maxLength={500}
                      placeholder={t('free_sample_popup.product_note_placeholder')} />
                  </Form.Item>
                </Form>
                : <div style={{ paddingBottom: '20px' }}>
                  <ol style={{ marginBottom: '10px' }}>
                    <li className={styles.infoText} style={{ marginTop: '17px', marginLeft: '15px' }}>
                      {t('free_sample_popup.click')} <span className={`${styles.infoTextDiff} underline `} onClick={(e) => { addChange(e); }}>{t('free_sample_popup.add_to_showcase_text')}</span> {t('free_sample_popup.add_to_showcase')}
                    </li>
                    <li className={styles.infoText} style={{ marginLeft: '15px' }}>
                      {t('free_sample_popup.check_tiktok')}<span className={styles.infoTextDiff}>{t('free_sample_popup.get_free_sample')}</span> {t('free_sample_popup.button')}
                    </li>
                    <li className={styles.infoText} style={{ marginLeft: '15px' }}>
                      {t('free_sample_popup.follow_process')} <span className={styles.infoTextDiff}>{t('free_sample_popup.follow_process_text1')}</span> {t('free_sample_popup.follow_process_text2')}
                    </li>
                    {/* <li className={styles.infoText} style={{ marginLeft: '15px' }}>
                      {t('free_sample_popup.request_sample_text1')} <span className={styles.infoTextDiff}>{t('free_sample_popup.request_sample')}</span> {t('free_sample_popup.request_sample_text2')}
                    </li> */}
                  </ol>
                  {/* <div className={styles.infoText} style={{ color: '#FF004F', marginTop: '0', marginBottom: '10px' }}>
                    <span style={{ fontWeight: '700' }}>{t('free_sample_popup.request_sample_note1')} </span>{t('free_sample_popup.request_sample_note2')}
                  </div> */}
                  <Image.PreviewGroup
                    items={currentLang.code === 'en' ? [FlowImg1, FlowImg2, FlowImg3, FlowImg4, FlowImg5, FlowImg6]
                      : [FlowImg1Fr, FlowImg2Fr, FlowImg3Fr, FlowImg4Fr, FlowImg5Fr, FlowImg6Fr]}
                  >
                    <Image
                      className={"object-cover"}
                      src={currentLang.code === 'en' ? AllFlowImg : AllFlowImgFr}
                    />
                  </Image.PreviewGroup>
                </div>
            )
            }
          </div>
        </div>}

        {/*       {steps !== 3 && <div className={styles.footer}>
          {steps === 0
            ? <div className={styles.footerBox}>
              <div className={styles.submit} onClick={getCapInvite}>Obtain Eligibility</div>
              <div className={styles.cancel} onClick={reEligible}>I'm already eligible</div>
            </div>
            : (steps === 2
              ? <div className={styles.footerBox}>
                <div className={styles.submit} onClick={handleSubmit}>Submit</div>
                <div className={styles.cancel} onClick={clearInfo}>Clear All</div>
              </div>
              : <div className={styles.request} onClick={getSample}>Request Sample Offline</div>)}

        </div>} */}
        {steps === 3 && <div className={styles.sampleSuccess}>
          <Icon icon='mdi:checkbox-marked-circle-auto-outline' className={styles.topIcon} />
          <div className={styles.text1}>{t('free_sample_popup.success.message')}</div>
          <ul className={styles.text2Box}>
            <li className={styles.text2}>{t('free_sample_popup.success.note1')}</li>
            <li className={styles.text2}>{t('free_sample_popup.success.note2')}</li>
          </ul>
        </div>}
      </div>
    </div >
  );
};
export default FreeSamplePopup;